export default function CurrencyFormatter(
  value: number,
  includeCurrency: boolean = true
) {
  const formatter = new Intl.NumberFormat("de-DE", {
    ...(includeCurrency && {
      style: "currency",
      currency: "EUR",
    }),
    maximumFractionDigits: 0,
  });
  return formatter.format(value);
}
